import React from "react";
import './PrivacyPolicy.css';
import ConsentFormData from "../../JsonFiles/LearnerPrivacyPolicy.json";

const renderFormattedText = (text) => {
    // Match bold (**text**) or italic (*text*) patterns
    return text.split(/(\*\*.*?\*\*|\*.*?\*)/g).map((part, index) => {
      if (part.startsWith("**") && part.endsWith("**")) {
        // Bold text
        return <strong key={index}>{part.slice(2, -2)}</strong>;
      } else if (part.startsWith("*") && part.endsWith("*")) {
        // Italic text
        return <em key={index}>{part.slice(1, -1)}</em>;
      }
      return part;
    });
  };
  

const ConsentForm = ({ setShowPrivacyPolicyPopup }) => {
  const handleClose = () => setShowPrivacyPolicyPopup(false);

  return (
    <>
    <div className={`LightBg partner-bg`} >
        <div className="MainParent bgGradient">
            <div
                className="FormParent bg-transparent md:bg-transparent"
                style={{ backgroundColor: "transparent" }}
            >
                <div
                style={{
                backgroundColor: "white",
                paddingBottom: "4rem", // md:pb-4, xl:pb-8
                display: "flex",
                alignItems: "flex-start",
                height: "fit-content",
                overflowX: "hidden",
                position: "relative",
                borderRadius: "11px",
                }}
                className={`w-full lg:w-[80%]`}
                >
                <div className="absolute top-2 right-2" onClick={handleClose}>
                <img
                    src={require("./Assets/InstituteCross.svg").default}
                    alt="close"
                    className="cursor-pointer w-[30px] h-[30px]"
                />
                </div>

                <div className="w-full py-[20px] pl-[30px] pr-[20px] lg:pl-[50px] lg:pr-[50px] flex flex-col gap-[10px]">
                    <p className="text-center text-[32px] font-bold">
                        {ConsentFormData.organizations}
                    </p>
                    <p className="text-center text-[22px] font-bold">{ConsentFormData.title}</p>
                    <p className="text-center text-[20px] italic">{ConsentFormData.subtitle}</p>

                    <div className="w-full bg-[#FAFAFA] p-[5px] lg:p-[20px] mt-[20px] h-[600px] overflow-y-auto rounded-lg shadow-md">
                        {ConsentFormData.content.map((item) => (
                        <div key={item.id} className="p-4 mb-4 text-[18px] lg:text-[20px]">
                            <p className="font-semibold mb-2">{item.title}</p>
                            {item.text.map((part, idx) => {
                            if (typeof part === "string") {
                                return (
                                <p key={idx} className="mt-2">
                                    {renderFormattedText(part)}
                                </p>
                                );
                            } else if (part.list) {
                                return (
                                <ul key={idx} className="list-disc ml-[25px] mt-2">
                                    {part.list.map((li, i) => (
                                    <li key={i}>{renderFormattedText(li)}</li>
                                    ))}
                                </ul>
                                );
                            } else if (part.subsection) {
                                return (
                                <div key={idx} className="mt-4">
                                    <p className="font-semibold">{part.subsection.title}</p>
                                    {part.subsection.text.map((subPart, subIdx) => {
                                    if (typeof subPart === "string") {
                                        return <p key={subIdx}>{renderFormattedText(subPart)}</p>;
                                    } else if (subPart.list) {
                                        return (
                                        <ul key={subIdx} className="list-disc ml-[25px] mt-2">
                                            {subPart.list.map((li, i) => (
                                            <li key={i}>{renderFormattedText(li)}</li>
                                            ))}
                                        </ul>
                                        );
                                    }
                                    return null;
                                    })}
                                </div>
                                );
                            }
                            return null;
                            })}
                        </div>
                        ))}
                    </div>

                {/* <div className="mt-[30px]">
                    <p className="text-[22px] font-bold mb-[10px]">{ConsentFormData.lastSection.title}</p>
                    <p className="text-[22px] mb-[10px]">{renderFormattedText(ConsentFormData.lastSection.text)}</p>
                </div> */}

                    <div className="flex justify-end gap-[20px] mt-[20px]">
                        <button
                        className="w-[130px] rounded-[8px] py-3 text-[16px] text-white bg-[#A1A3EF]"
                        onClick={handleClose}
                        >
                        Back
                        </button>
                    </div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </>
  );
};

export default ConsentForm;
